import PageHeader from '../../components/PageHeader/PageHeader';
import "../Style/style.css";
import { Row, Col, Form, Input, Checkbox, Tabs, Divider } from 'antd';
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import { getRights } from "../../redux/actions/userRights.action";
import { useSelector, useDispatch } from 'react-redux';
import { ReadCookie, } from '../../utils/readCookie';
import Tables from "../../components/Table/Tables"
import { logColumns, bergenBillingColumns } from "../../utils/cols";
import { getLog } from "../../redux/actions/log.action"
import notification from '../../utils/notification'
import { loadBergenBillingOption, addBerganBilling, updateBerganBilling, deleteBerganBilling } from '../../redux/actions/bergenBillingOption';
import { TabTitle } from '../../utils/GeneralFunction';


const { TabPane } = Tabs;

const BerganBilling = ({ token }) => {
    TabTitle("Bergan Billing")
    const { BergenBillingOption, userRights, log, } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const [description, setDescription] = useState('');
    const [form] = Form.useForm();
    const berganBillInput = useRef(null);
    const [disable, setDisable] = useState(false);
    const [berganBillingObj, setBerganBillingObj] = useState(null);
    const [check, setCheck] = useState(true);
    const dispatch = useDispatch();
    const id = ReadCookie('menuId');


    useEffect(() => {
        dispatch(loadBergenBillingOption(token))
    }, [dispatch, token])

    const handleDelete = () => {
        if (berganBillingObj) {

            dispatch(deleteBerganBilling(token, berganBillingObj.bergan_billing_id)).then((res) => {
                if (res.type === "GET_DELETE_BILLING_SUCCESS") {
                    notification("success", "Bergen Billing Deleted", "Record deleted successfully!");
                }
                if (res.type === "DELETE_BERGEN_BILLING_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    name: ""
                })
                // setCheck(false)
                setDescription("")
                setBerganBillingObj(null)
                setFormState('view')
                dispatch(loadBergenBillingOption(token, id))

            })
        }
        setFormState("view")
    }

    useEffect(() => {

        if (berganBillingObj) {
            setFormState('view')
            form.setFieldsValue({
                id: berganBillingObj.bergan_billing_id,
                name: berganBillingObj.bergan_billing_name,
                active: berganBillingObj.is_active,

            });

            setDescription(berganBillingObj.bergan_billing_name)
            setCheck(berganBillingObj.is_active)


        }

    }, [berganBillingObj]);

    useEffect(() => {
        if (description === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [description])




    useLayoutEffect(() => {
        dispatch(getRights(token, id)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        dispatch(getLog(token, { admin_bergan_billing: "admin_bergan_billing" }))
    }, [dispatch, token])


    const formSave = async () => {

        await form.validateFields().then((values) => {
            if (formState === "add") {
                dispatch(addBerganBilling(token, { bergan_billing_name: description, is_active: check }, id)).then((res) => {

                    if (res.type === "ADD_BERGEN_BILLING_ERROR") {
                        notification("error", "Not Created", res?.payload?.data?.data)
                    }
                    if (res.type === "ADD_BERGEN_BILLING_SUCCESS") {
                        notification("success", "Bergen Billing Created", "Bergen Billing created successfully!");
                        form.setFieldsValue({
                            name: ""
                        })
                        setFormState("view")
                        setDescription("")
                        setBerganBillingObj(null)
                    }
                    dispatch(loadBergenBillingOption(token, id))
                })
            }
            if (formState === "edit") {
                dispatch(updateBerganBilling(token, { bergan_billing_name: description, is_active: check }, berganBillingObj.bergan_billing_id)).then((res) => {

                    if (res.type === "UPDATE_BERGEN_BILLING_ERROR") {
                        notification("error", "Not update", "Something went wrong")
                    }
                    if (res.type === "UPDATE_BERGEN_BILLING_SUCCESS") {
                        notification("success", "Bergen Billing Updated", "Record updated successfully")
                    }
                    dispatch(loadBergenBillingOption(token, id))
                })
            }

        }).catch((err) => {

        })
    }

    useEffect(() => {
        if (formState === "add") {
            berganBillInput.current.focus()
            form.setFieldsValue({
                id: null,
                name: null,
            })
            setCheck(true)
            setDescription("")
            setBerganBillingObj(null)
        }
    }, [formState]);
    const filterReset = () => {
        setFormState("view")
        setBerganBillingObj(null)
        setCheck(true)
        form.setFieldsValue({
            id: null,
            name: null,
        })
        setDescription(null)
    }


    return (
        <div className='styleContainer'>
            <div className='styleBody h-100' >
                <PageHeader title={"Bergan Bill"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons formType={formState} rights={userRights?.payload} formState={setFormState} disable={disable} reset={filterReset} save={formSave} onDelete={handleDelete} /></div>
                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="bergenBilling" formState={formState} scrollX={"20rem"} berganBillingObj={setBerganBillingObj} source={BergenBillingOption?.payload?.data} col={bergenBillingColumns} paginate scroll={500} perPage={25} load={BergenBillingOption.loading} rowKey="bergan_billing_id" />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <div className='testStyle' >
                                            <Form
                                                form={form}
                                                name="basic"
                                            // labelCol={{ span: 8 }}

                                            >
                                                <div className='customRow styleFormUpper ' >
                                                    {berganBillingObj !== null && !(formState === "add") &&
                                                        <div className='customCols slc'>
                                                            <Form.Item
                                                                label="ID"
                                                                name="id"
                                                                initialValue={form.getFieldValue().id}
                                                                labelCol={{ span: 10 }}
                                                                wrapperCol={{ span: 14 }}

                                                            >
                                                                <Input size='small' className='styleInput id-field-style' readOnly />

                                                            </Form.Item>
                                                        </div>
                                                    }

                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Billing Name"
                                                            name="name"
                                                            initialValue={form.getFieldValue().desc}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >

                                                            <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={berganBillInput} onChange={(e) => setDescription(e.target.value)} className='styleInput' />
                                                        </Form.Item>
                                                    </div>
                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Active"
                                                            name="active"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>

                                        <div className='modalStyle' >


                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered  /**onChange={(key) => handleTab(key)} */ >
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={800} perPage={10} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </div>
                }
            </div>
        </div>





    )
}


export default BerganBilling